const configs  = {
    "system_name": "Efeeder",
    "system_version": "1.0.0",
    "logo": "/images/efeeder.png",
    "moto": "Efeeder",
    "system_website": "https://efeeder.co.tz",
}

export default configs;